/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e=3e5,o=5e5;export{o as distanceFadeEnd,e as distanceFadeStart};
